if (!customElements.get('intersection-box')) {
  customElements.define('intersection-box',
      class IntersectionBox extends HTMLElement {
        // 静态属性：声明要监听的属性（变化时自动触发）
        static get observedAttributes() {
          return ['data-root-margin'];
        }

        constructor() {
          super();

          this.intersectionHandler = this.intersectionHandler.bind(this);
          this.observer = null;
        }

        connectedCallback() {
          this.initObserver();
        }

        disconnectedCallback() {
          this.destroyObserver();
        }

        attributeChangedCallback() {
          this.destroyObserver();
          this.initObserver();
        }

        // 初始化监听
        initObserver() {
          if (this.observer) return;

          const rootMargin = this.dataset.rootMargin || '50px 0px';

          this.observer = new IntersectionObserver(this.intersectionHandler, {
            rootMargin: rootMargin,
            threshold: 0.1
          });

          this.observer.observe(this);
        }

        // 销毁监听（防止内存泄漏）
        destroyObserver() {
          if (this.observer) {
            this.observer.unobserve(this);
            this.observer.disconnect();
            this.observer = null;
          }
        }

        // 交叉监听回调
        intersectionHandler(entries) {
          const entry = entries[0];
          if (entry.isIntersecting) {
            this.classList.add('animate-intersection-el');
            // 动画触发后可以停止观察
            this.destroyObserver();
          }
        }
      }
  );
}
// multi language tanslate custom element
if(!customElements.get('multi-lang')){
  class MultiLang extends HTMLElement {
    connectedCallback() {
      try {
        const targetClass = this.dataset.targetClass;
        const currentLang = this.dataset.lang;
        let jsonString = this.dataset.json?.trim();

        if (!targetClass || !currentLang || !jsonString) return;
        const langData = JSON.parse(jsonString);

        const text = langData[currentLang] ?? langData.en ?? '';

        const targetEl = this.querySelector(`.${targetClass}`);
        if (targetEl) {
          targetEl.textContent = text.replace(/\\n/g, '\n');
        }
      } catch (err) {
        console.warn('MultiLang 错误：', err);
      }
    }
  }

  customElements.define('multi-lang', MultiLang);
}